import React from 'react'

import {
	CareerViewContainer,
	IconContainer,
	Text,
	IconWrapper
} from './CareerView.css'
import { IndustryDefaulIcon } from '../icons'
import Image from 'next/image'

interface IProps {
	industryName: string
	levelName: string
	isActive?: boolean
	icon?: string
	href?: string
}

const CareerView: React.FC<IProps> = ({
	industryName,
	levelName,
	isActive = false,
	icon = '',
	href
}) => {
	return (
		<CareerViewContainer
			isActive={isActive}
			href={href}
		>
			<IconContainer>
				{icon ? (
					<IconWrapper>
						<Image
							src={icon}
							width={56}
							height={56}
							alt={industryName}
							objectFit='contain'
						/>
					</IconWrapper>
				) : (
					<IndustryDefaulIcon />
				)}
			</IconContainer>
			<Text>
				<span className='title'>{industryName}</span>
				<span>{levelName}</span>
			</Text>
		</CareerViewContainer>
	)
}

export default CareerView
